'use client';
import { useMemo } from 'react';
import type { VerticalType } from '../../types';
import type { PanelTrackingContext } from './tracking';

/**
 * What every panel event needs and no control decides for itself. One owner, so
 * the panel and the applied-filter chips beside it cannot report a different
 * position or vertical for the same row.
 */
export const usePanelTrackingContext = (
  blockIndex?: number,
  vertical?: VerticalType,
): PanelTrackingContext =>
  useMemo(
    () => ({
      componentIndex: blockIndex != null ? String(blockIndex) : '',
      vertical,
    }),
    [blockIndex, vertical],
  );
